var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9251 20.5005C33.7969 20.5996 31.5328 21.8691 31.5328 24.692C31.5328 27.9571 34.4138 29.1122 34.5 29.1408C34.4867 29.2112 34.0423 30.7228 32.981 32.2629C32.0347 33.6183 31.0464 34.9714 29.5429 34.9714C28.0394 34.9714 27.6524 34.1023 25.9168 34.1023C24.2253 34.1023 23.6239 35 22.2487 35C20.8734 35 19.9138 33.7459 18.8105 32.2057C17.5326 30.3971 16.5 27.5875 16.5 24.9208C16.5 20.6436 19.2947 18.3751 22.0453 18.3751C23.5068 18.3751 24.725 19.33 25.6426 19.33C26.516 19.33 27.878 18.3179 29.5407 18.3179C30.1708 18.3179 32.4349 18.3751 33.9251 20.5005ZM28.7513 16.5072C29.439 15.6953 29.9254 14.5688 29.9254 13.4422C29.9254 13.286 29.9121 13.1276 29.8834 13C28.7646 13.0418 27.4335 13.7415 26.6309 14.6678C26.0008 15.3806 25.4127 16.5072 25.4127 17.6491C25.4127 17.8207 25.4414 17.9923 25.4547 18.0473C25.5254 18.0605 25.6404 18.0759 25.7554 18.0759C26.7592 18.0759 28.0217 17.407 28.7513 16.5072Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.a01a17d1077725b4031fd351e3ed4988.svg";
export { ForwardRef as ReactComponent };